const Backbone = require('backbone');
const parameters = require('../data/parameters.js');

const numberOfWeeks = parameters.get('weeks_to_display');

// locale FR
require('moment/locale/fr');

module.exports = {
  getDatesForNumberOfWeeks(date) {
    const dateArray = [];
    let i = 0;

    for (i = 0; i < numberOfWeeks; i++) {
      const dateClone = date.clone();
      dateClone.set('currentWeek', i);
      dateArray[i] = dateClone;
    }

    const dateCollection = new Backbone.Collection();
    dateCollection.set(dateArray);

    return dateCollection;
  }
};



// WEBPACK FOOTER //
// ./src/controllers/header.js